/* Copyright (c) 2017 Backpack Health LLC */
/* eslint-disable no-param-reassign */
import * as _ from 'lodash';

import { medliTermConversions } from './medliTerm';

function reaction(healthEntryCategoryState, languageCode) {
  healthEntryCategoryState.reaction = healthEntryCategoryState.reaction || [];

  return {
    get: () => healthEntryCategoryState.reaction,
    getUnique: () => _.uniqBy(healthEntryCategoryState.reaction, (a) => a.id),
    set: (reactionCollection) => { healthEntryCategoryState.reaction = reactionCollection; },
    hasReaction: () => healthEntryCategoryState.reaction.length > 0,
    addMedliSearchTerm: (medliSearchTerm) => {
      const newTerm = medliTermConversions.convertSearchTermToTerm(medliSearchTerm, languageCode);
      healthEntryCategoryState.reaction.push(newTerm);
    },
    remove: (unwantedReactionId) => { healthEntryCategoryState.reaction = healthEntryCategoryState.reaction.filter((a) => a.id !== unwantedReactionId); },
    count: () => healthEntryCategoryState.reaction.length,
    formattedNames: (forceLanguageCode) => {
      const code = forceLanguageCode || languageCode;
      return _.uniqBy(healthEntryCategoryState.reaction, (a) => a.id).map((a) => (
        a.strings[code]
      )).sort().join(', ');
    },
    clear: () => { healthEntryCategoryState.reaction = []; },
  };
}

export default reaction;
